import { render, staticRenderFns } from "./OrderOutsourcing.vue?vue&type=template&id=c23e02a0&"
import script from "./OrderOutsourcing.vue?vue&type=script&lang=js&"
export * from "./OrderOutsourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports